jQuery(document).ready(function($) {
	
	$('#tn-mobile-menu').mmenu();
	

	/* DATEPICKER
	========================================================================= */
	$('#from').datepicker({
		"minDate": 1,
		onClose: function( selectedDate ) {
			if( selectedDate )
				$( "#to" ).datepicker( "option", "minDate", selectedDate );
		}
	});

	$('#to').datepicker({
		"minDate": 1,
	});

	/* 	TOOGLE FAQ
	========================================================================= */
	$('.faq-block').on('touchend click', function() {
		$('.faq').find('.faq-block--active').removeClass('faq-block--active');
		$(this).addClass('faq-block--active');
	})

	/* FLEXSLIDER
	========================================================================= */
	$( '.flexslider' ).flexslider({
		animation: 'slide',
		prevText: "",
    	nextText: "",
	});

	/* CONTACT
	========================================================================= */
	var $cform = $('#contact-form'),
		url = $cform.attr('action');
	$cform.validate({
		submitHandler: function(form) {
			$('#submit-contact-form').attr('disabled', 'disabled');
			$.post(url, $cform.serialize()).done(function(result) {
				if( result === 'success') {
					swal("Nachricht gesendet", "Deine Anfrage wird schnellstmöglich beantwortet.", "success")
					swal({
						title: 'Nachricht gesendet',
						text: 'Deine Anfrage wird schnellstmöglich beantwortet.',
						type: 'success',
						confirmButtonColor: '#E84D22'
					})
					$cform.find('input[type="text"], input[type="email"], textarea').val('');
				} else {
					swal("Upps..", "Es gab Probleme beim Senden der Nachricht", "error");
					swal({
						title: 'Upps..',
						text: 'Es gab Probleme beim Senden der Nachricht. Schick uns bitte eine Email an info@tripnuts.de.',
						type: 'warning',
						confirmButtonColor: '#E84D22'
					})
				}
				$('#submit-contact-form').removeAttr('disabled');
			});
		},
		rules: {
			name: 'required',
			email: {
				required: true,
				email: true
			},
			message: 'required'
		},
		messages: {
			name: 'Pflichtfeld',
			email: 'Pflichtfeld',
			nachricht: 'Pflichtfeld'
		}
	});

});